import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { ThemeProvider } from '@mui/material';

import { customTheme } from '../../libs';

export const CalendarDatePicker = ({ date, handleSetDate }) => {
  return (
    <ThemeProvider theme={customTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateCalendar className="calendar-date-picker" onChange={handleSetDate} value={date} />
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default CalendarDatePicker
